// TITAN RESPONSIVE SYSTEM v2.1 - JavaScript Component
// Extracted from theme.liquid

(function() {
    'use strict';
    var TITAN_BREAKPOINT = 400;

    function titanFix() {
        if (window.innerWidth > TITAN_BREAKPOINT) return;

        // FIX 1: Grey buttons (VIEW PRODUCT) - prevent text splitting
        var greyButtons = document.querySelectorAll('a[style*="background:#C0C0C0"], a[style*="background: #C0C0C0"], td[style*="background:#C0C0C0"]');
        greyButtons.forEach(function(el) {
            el.style.whiteSpace = 'nowrap';
            el.style.overflow = 'hidden';
            el.style.textOverflow = 'ellipsis';
            el.style.display = 'block';
            el.style.width = '100%';
        });

        // FIX 2: Hot Items small cards - stack image and text vertically
        var smallImages = document.querySelectorAll('td img[style*="width:80px"], td img[style*="width: 80px"]');
        smallImages.forEach(function(img) {
            var parentTd = img.closest('td');
            if (parentTd && parentTd.getAttribute('width') === '80') {
                parentTd.style.display = 'block';
                parentTd.style.width = '100%';
                parentTd.style.textAlign = 'center';
                img.style.width = '150px';
                img.style.height = '150px';
                img.style.margin = '0 auto 8px auto';
                img.style.display = 'block';
            }
        });

        // FIX 3: Table cells with width="80" (small card image cells)
        var smallCells = document.querySelectorAll('td[width="80"]');
        smallCells.forEach(function(el) {
            // SKIP if inside .resp-grid - those must stay side-by-side
            if (el.closest('.resp-grid')) return;
            el.style.display = 'block';
            el.style.width = '100%';
            el.style.textAlign = 'center';
        });

        // FIX 4: Product grid cells with 50% width - BUT SKIP .resp-grid children
        var productGridCells = document.querySelectorAll('td[width="50%"]');
        productGridCells.forEach(function(el) {
            // SKIP if inside .resp-grid - those must stay side-by-side
            if (el.closest('.resp-grid')) return;

            var hasProductImage = el.querySelector('img[alt]') || el.querySelector('a[href*="products"] img');
            var hasProductStyle = el.style.cssText.indexOf('background') > -1 || el.style.cssText.indexOf('border') > -1;

            if (hasProductImage && hasProductStyle) {
                el.style.cssText += 'display:block!important;width:100%!important;float:none!important;margin-bottom:10px!important;';
            }
        });

        // FIX 5: Ensure button containers stack vertically
        var buttonContainers = document.querySelectorAll('div[style*="margin-top"]');
        buttonContainers.forEach(function(el) {
            if (el.querySelector('a.green-pulse-btn') || el.querySelector('a.purple-btn') || el.querySelector('a[onclick*="quickAdd"]')) {
                el.style.display = 'flex';
                el.style.flexDirection = 'column';
                el.style.gap = '4px';
                el.style.width = '100%';
            }
        });

        // FIX 6: Cart quantity buttons - MUST be horizontal (REMOVED - CSS handles this now)

        // FIX 7: All links/buttons with inline background styles
        var allStyledLinks = document.querySelectorAll('a[style*="background"]');
        allStyledLinks.forEach(function(el) {
            if (el.style.cssText.indexOf('linear-gradient') > -1 || el.style.cssText.indexOf('#C0C0C0') > -1) {
                el.style.whiteSpace = 'nowrap';
                el.style.overflow = 'hidden';
                el.style.textOverflow = 'ellipsis';
            }
        });

        // FIX 8: PROTECT .resp-grid elements - restore flexbox side-by-side
        var respGrids = document.querySelectorAll('.resp-grid');
        respGrids.forEach(function(grid) {
            grid.style.cssText = 'display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;gap:4px!important;visibility:visible!important;overflow:visible!important;';
            var children = grid.children;
            for (var i = 0; i < children.length; i++) {
                children[i].style.cssText += 'flex:1 1 0!important;min-width:0!important;visibility:visible!important;overflow:visible!important;';
            }
        });

        console.log('[TITAN v2.1] Comprehensive fixes applied for ' + window.innerWidth + 'px viewport');
    }

    // Run on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', titanFix);
    } else {
        titanFix();
    }

    // Run on window load (after all resources)
    window.addEventListener('load', function() {
        titanFix();
        // Run again after delays for dynamically loaded content
        setTimeout(titanFix, 500);
        setTimeout(titanFix, 1500);
        setTimeout(titanFix, 3000);
    });

    // Run on resize
    var resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(titanFix, 100);
    });
})();


// JAVASCRIPT v17: NUCLEAR SUB-500px FIX

(function() {
    'use strict';

    var MOBILE_BREAKPOINT = 1000;
    var NARROW_BREAKPOINT = 520; // v17: Critical breakpoint
    var DEBUG = true;

    function log(msg) {
        if (DEBUG) console.log('[v17] ' + msg);
    }

    function isMobile() {
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function isNarrow() {
        return window.innerWidth <= NARROW_BREAKPOINT;
    }

    // v17: NUCLEAR - Hide ASCII art on narrow screens
    function hideAsciiArt() {
        if (!isNarrow()) return;

        log('NUCLEAR: Hiding ASCII art on narrow screen (' + window.innerWidth + 'px)');

        // Hide ALL pre elements
        var pres = document.querySelectorAll('pre, .stop-scrolling-text, .join-now-text, .save-text, .ascii-rainbow, .ascii-color, .stop-scrolling-box');
        pres.forEach(function(el) {
            el.style.cssText = 'display:none!important;visibility:hidden!important;width:0!important;height:0!important;overflow:hidden!important;position:absolute!important;left:-9999px!important;';
        });
        log('Hidden ' + pres.length + ' ASCII/pre elements');

        // Hide badge images (88x31)
        var badges = document.querySelectorAll('img[width="88"][height="31"], img[width="88"]');
        badges.forEach(function(badge) {
            badge.style.cssText = 'display:none!important;';
        });
        log('Hidden ' + badges.length + ' badge images');
    }

    function forceFullWidth() {
        if (!isMobile()) {
            log('Desktop mode - skipping mobile fixes');
            return;
        }

        log('Applying v17 mobile full-width fixes...');
        log('Viewport width: ' + window.innerWidth + 'px');
        log('Is narrow (<' + NARROW_BREAKPOINT + 'px): ' + isNarrow());

        // v17: NUCLEAR - Hide ASCII on narrow screens FIRST
        hideAsciiArt();

        // 1. Force HTML and Body with overflow containment - USE 100vw
        document.documentElement.style.cssText = 'width:100vw!important;max-width:100vw!important;margin:0!important;padding:0!important;overflow-x:hidden!important;';
        // Preserve existing background image before overwriting styles
        var existingBg = document.body.style.backgroundImage;
        document.body.style.cssText = 'width:100vw!important;max-width:100vw!important;min-width:0!important;margin:0!important;padding:0!important;overflow-x:hidden!important;';
        // Restore the flag background if it was set
        if (existingBg) {
            document.body.style.backgroundImage = existingBg;
        }

        // 2. Force site-wrapper with overflow hidden - USE 100vw
        var wrapper = document.getElementById('site-wrapper');
        if (wrapper) {
            wrapper.style.cssText = 'width:100vw!important;max-width:100vw!important;min-width:0!important;margin:0!important;padding:0!important;display:block!important;overflow-x:hidden!important;';
            log('site-wrapper forced to 100vw');
        }

        // 3. Remove ALL width HTML attributes from tables - SKIP .resp-grid parents
        var tables = document.querySelectorAll('table');
        log('Found ' + tables.length + ' tables');
        tables.forEach(function(table, index) {
            // SKIP if inside .resp-grid - those must stay intact
            if (table.closest('.resp-grid')) return;

            // Remove HTML width attribute
            if (table.hasAttribute('width')) {
                var oldWidth = table.getAttribute('width');
                table.removeAttribute('width');
                log('Removed width="' + oldWidth + '" from table #' + index);
            }
            // Force CSS width - v17: use 100% and max-width: 100vw
            table.style.cssText = 'width:100%!important;max-width:100vw!important;min-width:0!important;margin:0!important;box-sizing:border-box!important;overflow:hidden!important;';
        });

        // 4. Special handling for master-table (remove side borders only)
        var masterTables = document.querySelectorAll('.master-table');
        masterTables.forEach(function(table) {
            table.removeAttribute('width');
            // Remove side borders only
            table.style.cssText = 'width:100%!important;max-width:100%!important;min-width:0!important;margin:0!important;border-left:none!important;border-right:none!important;overflow:hidden!important;';
        });

        // 4b. Flag border table - KEEP ALL BORDERS (decorative element)
        var flagTables = document.querySelectorAll('.flag-border-table');
        flagTables.forEach(function(table) {
            table.removeAttribute('width');
            // Keep all styling, just force width
            table.style.width = '100%';
            table.style.maxWidth = '100%';
            table.style.minWidth = '0';
            table.style.margin = '0';
        });

        // 5. Force center tags with overflow hidden
        var centers = document.querySelectorAll('center');
        centers.forEach(function(center) {
            // SKIP if inside .resp-grid - those must stay intact
            if (center.closest('.resp-grid')) return;
            center.style.cssText = 'display:block!important;width:100%!important;max-width:100vw!important;min-width:0!important;margin:0!important;overflow:hidden!important;';
        });

        // 6. Force ALL TDs to allow content wrapping
        var allTds = document.querySelectorAll('td, th');
        allTds.forEach(function(td) {
            // SKIP if inside .resp-grid - those must stay side-by-side
            if (td.closest('.resp-grid')) return;
            // Remove width attribute
            if (td.hasAttribute('width')) {
                td.removeAttribute('width');
            }
            // v17: Use word-break: break-all for narrow screens
            var wordBreak = isNarrow() ? 'break-all' : 'break-word';
            td.style.cssText += 'max-width:100vw!important;min-width:0!important;word-wrap:break-word!important;overflow-wrap:anywhere!important;word-break:' + wordBreak + '!important;overflow:hidden!important;';
        });

        // 7. Force images to be responsive - v17: ALL images, not just large ones
        var images = document.querySelectorAll('img');
        images.forEach(function(img) {
            var w = img.getAttribute('width');
            // v17: On narrow screens, force ALL images to be responsive
            if (isNarrow() || (w && parseInt(w) > 100)) {
                img.removeAttribute('width');
                img.style.cssText += 'max-width:100%!important;height:auto!important;';
            }
        });

        // 8. Force marquee to respect container
        var marquees = document.querySelectorAll('marquee');
        marquees.forEach(function(m) {
            m.style.cssText = 'width:100%!important;max-width:100vw!important;min-width:0!important;overflow:hidden!important;';
        });

        // 9. Report actual widths for debugging
        if (wrapper) {
            log('site-wrapper actual width: ' + wrapper.offsetWidth + 'px');
            log('body actual width: ' + document.body.offsetWidth + 'px');
            log('viewport width: ' + window.innerWidth + 'px');

            // Check if content is overflowing
            if (wrapper.scrollWidth > wrapper.offsetWidth) {
                log('WARNING: Content overflow detected! scrollWidth=' + wrapper.scrollWidth + ', offsetWidth=' + wrapper.offsetWidth);
            }
        }

        // v17: Force cart drawer and search input
        var cartWindow = document.getElementById('retro-cart-window');
        if (cartWindow) {
            cartWindow.style.cssText += 'width:100vw!important;max-width:100vw!important;left:0!important;right:0!important;';
            log('Cart drawer forced to 100vw');
        }

        // v17: Force all inputs to be responsive
        var inputs = document.querySelectorAll('input[type="text"], input[type="search"], .search-input');
        inputs.forEach(function(input) {
            input.style.cssText += 'width:100%!important;max-width:100%!important;min-width:0!important;';
        });

        log('v17 fixes applied. Tables: ' + tables.length + ', TDs: ' + allTds.length + ', Narrow mode: ' + isNarrow());
    }

    // CRITICAL: Restore .resp-grid elements - run AFTER all other fixes
    function protectRespGrids() {
        var grids = document.querySelectorAll('.resp-grid');
        grids.forEach(function(grid) {
            // Force flexbox side-by-side layout
            grid.style.cssText = 'display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;gap:4px!important;visibility:visible!important;overflow:visible!important;position:relative!important;left:auto!important;height:auto!important;' + (grid.style.marginTop || grid.style.margin ? 'margin-top:' + (grid.style.marginTop || '4px') + '!important;' : '');
            // Also protect children
            var children = grid.children;
            for (var i = 0; i < children.length; i++) {
                children[i].style.cssText += 'flex:1 1 0!important;min-width:0!important;visibility:visible!important;overflow:visible!important;display:block!important;';
            }
        });
        if (grids.length > 0) {
            log('Protected ' + grids.length + ' .resp-grid elements');
        }
    }

    // v17: NUCLEAR - Find and eliminate ALL overflow sources
    function findOverflowSources() {
        if (!isNarrow()) return;

        var viewportWidth = window.innerWidth;
        var allElements = document.querySelectorAll('*');
        var overflowElements = [];

        allElements.forEach(function(el) {
            // SKIP if inside .resp-grid or IS .resp-grid - those must stay intact
            if (el.classList.contains('resp-grid') || el.closest('.resp-grid')) return;
            if (el.offsetWidth > viewportWidth) {
                overflowElements.push({
                    element: el,
                    width: el.offsetWidth,
                    tag: el.tagName,
                    class: el.className,
                    id: el.id
                });
                // FORCE FIX IT
                el.style.cssText += 'max-width:100vw!important;width:100%!important;overflow:hidden!important;';
            }
        });

        if (overflowElements.length > 0) {
            log('NUCLEAR: Found ' + overflowElements.length + ' overflowing elements, forcing to viewport width');
            overflowElements.forEach(function(item) {
                log('  - ' + item.tag + (item.id ? '#' + item.id : '') + (item.class ? '.' + item.class.split(' ')[0] : '') + ' was ' + item.width + 'px');
            });
        }
    }

    // Run at multiple points to catch everything

    // 1. Run immediately (catches elements already in DOM)
    if (document.readyState !== 'loading') {
        forceFullWidth();
        protectRespGrids(); // Always restore .resp-grid AFTER fixes
    }

    // 2. Run on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', function() {
        forceFullWidth();
        findOverflowSources(); // v17
        protectRespGrids(); // Always restore .resp-grid AFTER fixes
        log('DOMContentLoaded - v17 fixes applied');
    });

    // 3. Run on window load (after all resources)
    window.addEventListener('load', function() {
        forceFullWidth();
        findOverflowSources(); // v17
        protectRespGrids(); // Always restore .resp-grid AFTER fixes
        log('Window load - v17 fixes applied');
    });

    // 4. Run after short delays to catch late JavaScript
    setTimeout(function() { forceFullWidth(); protectRespGrids(); }, 100);
    setTimeout(function() { forceFullWidth(); protectRespGrids(); }, 500);
    setTimeout(function() {
        forceFullWidth();
        findOverflowSources(); // v17: Final sweep
        protectRespGrids(); // Always restore .resp-grid AFTER fixes
    }, 1000);
    setTimeout(function() { findOverflowSources(); protectRespGrids(); }, 2000); // v17: Extra sweep

    // 5. Run on resize
    var resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            forceFullWidth();
            findOverflowSources();
            protectRespGrids(); // Always restore .resp-grid AFTER fixes
        }, 100);
    });

    // 6. MutationObserver to catch dynamically added elements
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            var needsFix = false;
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1 && (node.tagName === 'TABLE' || node.tagName === 'PRE' || node.querySelector && (node.querySelector('table') || node.querySelector('pre')))) {
                            needsFix = true;
                        }
                    });
                }
            });
            if (needsFix && isMobile()) {
                log('New tables/pre detected - reapplying v17 fixes');
                forceFullWidth();
                if (isNarrow()) hideAsciiArt();
                protectRespGrids(); // Always restore .resp-grid AFTER fixes
            }
        });

        // Start observing once DOM is ready
        document.addEventListener('DOMContentLoaded', function() {
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            log('v17 MutationObserver started');
        });
    }
})();
